module.exports = __webpack_public_path__ + "img/moving_forward.94d70108.png";